import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { IMAGES_REPO } from '../../config';

class Event extends PureComponent {

  render() {
    const { code, last, sub_title, title, body, start_date, end_date, gallery, id, image, is_soon } = this.props;
    const mStart_date = moment(new Date(start_date)).format('D');
    const mEnd_date = moment(new Date(end_date)).format('DD MMMM YYYY');
    return (
      <div className="event">
        <div className="row">
          <div className="col-md-5">
            <Link to={`/events/${code}`}>
              <img
                className="event__image img-responsive"
                src={`${IMAGES_REPO}${image}`}
                alt="image"/>
            </Link>
          </div>
          <div className="col-md-7">
            <div className="event__information">
              <Link to={`/events/${code}`}>
                <h2>{title}</h2>
              </Link>
              <Link to={`/events/${code}`}>
                {
                  last ?
                    is_soon ? '' : <p>{sub_title}</p>
                    :
                    is_soon ? '' : <p>{sub_title} {is_soon ? '' : mStart_date + ' a ' + mEnd_date}</p>
                }
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Event.propTypes = {};
Event.defaultProps = {};

export default Event;



// WEBPACK FOOTER //
// ./src/components/event/Event.js